// extracted by mini-css-extract-plugin
export default {"swiper":"imageSlider_swiper__m167N","swiper-slide":"imageSlider_swiper-slide__1hnTl"};